function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3478 13.125V18.375C24.3478 18.5437 24.3284 18.7118 24.29 18.876L22.5509 26.3135C22.3198 27.3016 21.4435 28 20.4347 28H9.1304C8.78751 28 8.44948 27.9184 8.14392 27.7618C7.83837 27.6052 7.57394 27.3782 7.37225 27.0991L0.415895 17.4741C-0.290246 16.4971 -0.075572 15.129 0.895351 14.4184C1.86638 13.7078 3.226 13.9239 3.93214 14.9009L5.65214 17.2808V2.1875C5.65214 0.979398 6.6254 0 7.82605 0C9.0267 0 9.99996 0.979398 9.99996 2.1875V13.125H10.4347V10.9375C10.4347 9.7294 11.408 8.75 12.6087 8.75C13.8093 8.75 14.7826 9.7294 14.7826 10.9375V13.125H15.2174V11.8125C15.2174 10.6044 16.1906 9.625 17.3913 9.625C18.5919 9.625 19.5652 10.6044 19.5652 11.8125V13.125H20C20 11.9169 20.9732 10.9375 22.1739 10.9375C23.3745 10.9375 24.3478 11.9169 24.3478 13.125ZM10.4347 17.5H9.99996V22.75H10.4347V17.5ZM15.2174 17.5H14.7826V22.75H15.2174V17.5ZM20 17.5H19.5652V22.75H20V17.5Z",
  fill: "#15AEFF"
});
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.d4d237b54d7062e61625be4137aab749.svg";
export { ForwardRef as ReactComponent };